/**
 * Version-agnostic UUID, matching `validator`'s default `isUUID` and the
 * `UUID_PATTERN` cosmos applies before bucketing a viewer
 * (`cosmos/src/components/marketplace/helpers/useSearchQueries.ts`). Narrowing
 * this to v4 would reject ids already in circulation and silently drop those
 * viewers out of every experiment that gates on identity.
 */
const UUID_PATTERN =
  /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/iu;

export const isUuid = (value: string): boolean => UUID_PATTERN.test(value);
